var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var session = require('../../auth/models/session');
var edit = require('../../layout/components/edit');
var loaders = require('../../layout/components/loaders');

var smartTableSearch = {};

function setSearchValue(vnode, value) {
  vnode.attrs.searchEquipmentValue(value);
  if (typeof vnode.attrs.onSearchChange === 'function') {
    vnode.attrs.onSearchChange(value);
  }
}

var restoreEditShortcut = function () {
  key.unbind('e', 'all');
  key.unbind('e', 'home');
  key('e', function () {
    if (session.user().isSuperuser == 1) {
      edit.vm.toggle();
      m.redraw();
    }
  });
};

let handleClickOutside = (e, vnode) => {
  const searchElement = document.getElementById('searchEquipmentSpan-' + vnode.attrs.elementRid);
  const searchInputElement = document.getElementById('smarttable-search-input-' + vnode.attrs.elementRid);
  const smartTableContainer = document.getElementById('smart-table-container-' + vnode.attrs.elementRid);

  // If the click is outside the search area, set searchEquipmentActive to false
  if (
    searchElement &&
    !searchElement.contains(e.target) &&
    searchInputElement &&
    !searchInputElement.contains(e.target) &&
    smartTableContainer &&
    !smartTableContainer.contains(e.target)
  ) {
    vnode.attrs.searchEquipmentActive(false);
    setSearchValue(vnode, '');
    m.redraw();
  }
};
smartTableSearch.oninit = function(vnode) {
  // Add the event listener on component mount
  this.clickOutsideHandler = (e) => handleClickOutside(e, vnode);
  document.addEventListener('click', this.clickOutsideHandler);
};

smartTableSearch.onremove = function(vnode) {
  // Clean up the event listener when the component is removed
  if (this.clickOutsideHandler) {
    document.removeEventListener('click', this.clickOutsideHandler);
  }
  restoreEditShortcut();
};

smartTableSearch.view = function(vnode) {
  return m('div.flex.items-end', [
    m(`span${vnode.attrs.searchEquipmentActive() ? '.w4.ba.b--blue.br2.ph1.flex.items-center.mr2.h2' : ''}`, {
      id: 'searchEquipmentSpan-'+vnode.attrs.elementRid,
      onclick: (e) => {
        vnode.attrs.searchEquipmentActive(true);
        setTimeout(function() { 
          document.getElementById('smarttable-search-input-'+vnode.attrs.elementRid).focus(); 
        }, 1);
      }
    }, [
      m('div.nowrap', {style: {display: (vnode.attrs.searchEquipmentActive() ? 'none' : 'block')}}, [
        m('i', {
          class: 'blue f2 ion-search pointer',
        })
      ]),
      m('div.flex.items-center', {style: {display: (vnode.attrs.searchEquipmentActive() ? 'flex' : 'none')}}, [
        m('input.mh1.mv1.w4.f4', {
          id: 'smarttable-search-input-'+vnode.attrs.elementRid,
          class: 'smarttable-search-input',
          placeholder: `Search ${vnode.attrs.title}`,
          value: vnode.attrs.searchEquipmentValue(),
          oninput: function (ev) { 
            setSearchValue(vnode, ev.target.value);
          },
          onblur: (e) => {
            if (vnode.attrs.searchEquipmentValue().length == 0) {
              vnode.attrs.searchEquipmentActive(false);
            }
            restoreEditShortcut();
          },
          onfocusin: (e) => {
            key.unbind('e');
          }
        }),
        vnode.attrs.searchEquipmentValue() && vnode.attrs.searchEquipmentValue().length > 0 ? 
          m('i', {
            class: 'blue f4 mr1 ion-close-circled pointer',
            onclick: (e) => {
              setSearchValue(vnode, '');
              vnode.attrs.searchEquipmentActive(false);
            }
          })
        :
          ''
      ])
    ])
  ]);
};

module.exports = smartTableSearch;
